module.exports = __webpack_public_path__ + "static/1331365061-exit.c542bc67.jpg";